import React from "react";
import "./FourSection.css";
import tiffanyPhoto from "../../accets/tiffanyPhoto/tiffanyPhotoOne.png";
import fourSectionPhoto from "../../accets/fourSectionPhoto/fourSectionPhoto.jpg";
import logoOne from "../../accets/tifany_logo/logoOne.png";
import logoTwo from "../../accets/tifany_logo/logoTwo.png";

const SectionFour = () => {
  return (
    <div className="sectionFour_main_div">
      <div className="four_section_parent_div">
        <div>
          <h4 className="why_i_do">Why I Do What I Do</h4>
          <img
            className="sectionFour_tiffany_photo"
            src={fourSectionPhoto}
            alt=""
          />
          <div className="four_section_grid_div">
            <p className="four_section_cart_p_one">
              I wanted a marriage that was loving, respectful, & supportive. I
              faced challenges including unruly emotions, emotional abuse, &
              constant disrespect. I had been doing research for months, & when
              I came across a term called Emotional Intelligence, it all started
              to make sense.
            </p>
            <p className="four_section_cart_p_two">
              I spent over 8 years researching & studying the subject. I took
              personal time to focus on myself, & my mindset changed from
              negative to positive; it felt like empowerment! I learned how
              important it is not only for me & for others in any kind of
              relationship, that when you learn about yourself as well as manage
              your feelings, you will not become overwhelmed by angry outbursts
              or choices you will regret.
            </p>
            <p className="four_section_cart_p_three">
              I learned that I could brilliantly become more in-tune with myself
              by tapping into my own feelings for guidance and for help to make
              the right choices, hence the definition of Emotional Intelligence.
              I know now that we have all the power and brilliance already
              inside of us that can easily be tapped into when we are open,
              conscious, & willing. It was enlightening to learn that my having
              a deep understanding of myself will help me have better
              relationships with those I love & to navigate the challenges of
              life more successfully.
            </p>
            <p className="four_section_cart_p_four">
              It's time to get in-tune with yourself &/or to support those you
              serve or who serve you. I offer an eight-step process called the
              Why You Matter Playbook. It is a 6-week interactive and
              knowledge-based course, in-person or through a group setting, that
              helps you understand yourself, your emotions, & use what you learn
              as new information to help you move toward the desired outcomes
              that you want in your life & business.
            </p>
          </div>
        </div>
      </div>
      <div className="tiffany_bio_parent_div">
        <div className="tiffany_bio_div">
          <img className="tiffany_bio_photo" src={tiffanyPhoto} alt="" />
          <p className="tiffany_J_p">
            Tiffany J. Norwood, CNLP, CEQP, is the founder & CEO of Your
            Emotions Matter, Life Coach for Athletes, Transformational speaker,
            & author. She is a certified NLP practitioner (Neurolinguistic
            programming is the study of how language is represented in the
            brain) & a certified Six Seconds Emotional Intelligence practitioner
            (how to be smarter with feelings). Your Emotions Matter’s mission is
            to break the cycle and silence of unhealthy relationships, to break
            the stigma in men around asking for help, and to spread awareness
            and education around Emotional Intelligence through exclusive
            coaching. Tiffany J. addresses communication issues, limiting
            beliefs, & habits that do not serve her clients. In addition, she
            assists them in understanding, feeling, expressing, & navigating
            their emotions. Leaving them to feel more aware, secure, peaceful, &
            confident, resulting in effective communication & the genuine
            success they desire within themselves, their relationships, & in
            life in general. Tiffany J. is also a Course Partner for Postseason,
            founded by NFL Vet Jelani Jenkins, an online platform to empower
            current & former athletes by giving them the tools and support to
            find new purpose in life after their professional sports careers
            end.{" "}
          </p>
        </div>

        <div className="tiffany_logo_div">
          <img className="logo_one" src={logoOne} alt="" />
          <img className="logo_two" src={logoTwo} alt="" />
        </div>
      </div>
    </div>
  );
};

export default SectionFour;
